import { Dispatch } from 'redux';
import * as actions from './actionCatalog';
import * as http from '../http';
import { Reader } from 'reducers/readersReducer';

const regularGetReaders = (dispatch: Dispatch) => http.get<Reader[]>(actions.GET_READERS, dispatch);
export const getReaders = () => regularGetReaders;
